import { PaginationService } from "./pagination.service";

export abstract class Pagination
{	
	protected paginationService :PaginationService = new PaginationService();
	constructor()
	{

	}
	// Handler for rows per page change, updates the page selection size in cookies using the dynamic table id
	onRowsPerPageChange(event: any, tableUniferId: number, tableSize: number) 
	{
		return this.paginationService.onRowsPerPageChange(event, tableUniferId, tableSize, this.constructor.name.substring(1))
	}

	setPaginator(allValue: number): number[] {
		return this.paginationService.getPersonalPagination(allValue);
	}

	getCurrentPageSize(tableUniferId: number, currentMaxSize: number): number 
	{
		return this.paginationService.getCurrentPageSize(tableUniferId, currentMaxSize, this.constructor.name.substring(1));
	}
}